module.exports = __webpack_public_path__ + "img/ydd_qyh_page2.3725b095.png";